import { createSlice } from '@reduxjs/toolkit'
import { fetchHeroBanners } from '../actions/bannerActions'

const BannerReducers = createSlice({
    name: 'BannerReducers',
    initialState: {
        loader: false,
        errors: null,
        heroBanners: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            /**
             * HERO BANNERS
             */
            .addCase(fetchHeroBanners.pending, (state) => {
                state.loader = true;
                state.errors = null; // Clear any existing errors
            })
            .addCase(fetchHeroBanners.fulfilled, (state, action) => {
                state.loader = false;
                state.heroBanners = action.payload; // Store the fetched banners
            })
            .addCase(fetchHeroBanners.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; // Set the error message if the request failed
            });
    }
})

export default BannerReducers.reducer